module.exports = __webpack_public_path__ + "static/media/evolving-sol-light-mode.7d1b58eb.png";